import React from "react";
import { useNavigate } from "../../components/hooks/hooks";
import bannerImg from './images/home-banner-img.jpg'
import UserImg01 from './images/user01.jpg'
import UserImg02 from './images/user02.jpg'
import UserImg03 from './images/user03.jpg'
import UserImg04 from './images/user04.jpg'
import UserImg05 from './images/user05.jpg'
import { FiChevronRight } from "react-icons/fi";
import useIntersectionObserver from "./home-animation";
export default function Homebanner({siteDetails}) {
    console.log(siteDetails,"siteDetails");   
    const navigate=useNavigate();
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef3, isVisible3] = useIntersectionObserver({ threshold: 0.1 });

    const goToCareers = () => {
        navigate(`/careers/${siteDetails.id}`);
      };
    return (
            <div className="home-banner">
                <div className="home-banner-overlay"></div>
                <div className="outer-container">
                <div className="home-banner-left">
                    <div className="home-banner-left-container">
                    <h1 className={`home-banner-head ${isVisible1? 'animate__fadeInLeft' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef1}>Connecting Talent with Opportunities</h1>
                    <p className={`home-banner-para ${isVisible2 ? 'animate__fadeInLeft' : ''}`} style={{ animationDuration: '1.25s',animationDelay: '240ms' }}  ref={sectionRef2}>Empowering businesses and professionals with seamless hiring solutions. Upload resumes, search for the perfect candidates, create job descriptions, schedule interviews, and send offer letters with ease.</p>
                    <button type="button" className="home-page-btn1" onClick={() => goToCareers()}>Find Your Next Job<FiChevronRight style={{width:'20px', height:'20px'}}/></button>
                    <div className="home-active-members">
                        <div className="left-home-active-members">
                            <ul className="home-active-ul">
                                <li className="home-active-li">
                                    <img src={UserImg01} alt="user" width="300" height="300"/>
                                </li>
                                <li className="home-active-li">
                                    <img src={UserImg02} alt="user" width="300" height="300"/>
                                </li>
                                <li className="home-active-li">
                                    <img src={UserImg03} alt="user" width="300" height="300"/>
                                </li>
                                <li className="home-active-li">
                                    <img src={UserImg04} alt="user" width="300" height="300"/>
                                </li>
                                <li className="home-active-li">
                                    <img src={UserImg05} alt="user" width="300" height="300"/>
                                </li>
                            </ul>
                        </div>
                        <div className="right-home-active-members">
                        <h2 className="home-active-head">Join Our Vibrant and Active Member Community</h2>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="home-banner-right">
                    <div className={`home-banner-right-outer ${isVisible3 ?'animate__fadeInUp' : ''}`} style={{ animationDuration: '1.25s' }}  ref={sectionRef3}>
                         <img src={bannerImg} className="img-fluid home-banner-right-outer-img" alt="banner-img" width="600" height="900"/>
                    </div>
                </div>
                </div>
            </div>
    );
}
